var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-two"},[(_vm.getAccountType === 'Diaspora')?_c('IllustrationLayout',{attrs:{"illustrationImg":_vm.illustrationImg}}):_vm._e(),(_vm.getAccountType === 'Startup')?_c('IllustrationLayout',{attrs:{"illustrationImg":_vm.illustrationImgStartUp}}):_vm._e(),_c('StepThreeContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }